// extracted by mini-css-extract-plugin
export default {"mask":"mask-RbD4nW","content":"content-AprpOb","closeIcon":"closeIcon-b8a9Yt"};